import { render, staticRenderFns } from "./DesignationEdit.vue?vue&type=template&id=ea6d0002"
import script from "./DesignationEdit.vue?vue&type=script&lang=js"
export * from "./DesignationEdit.vue?vue&type=script&lang=js"
import style0 from "./DesignationEdit.vue?vue&type=style&index=0&id=ea6d0002&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports